import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';
import { prefetchGridSchema } from '../-utils/loaders';

export const Route = createFileRoute('/_authenticated/shifts')({
  loader: ({ context }) =>
    prefetchGridSchema(context.queryClient, baseModuleConfigs.Shifts.itemType),
  component: () => <BaseView configuration={baseModuleConfigs.Shifts} />,
});
